export default __webpack_public_path__ + "static/media/IconQuality.8864b31a.png";